var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useState, } from 'react';
import styled from 'styled-components';
import { space, layout } from 'styled-system';
export function Icon(_a) {
    var { name, className = '' } = _a, props = __rest(_a, ["name", "className"]);
    const hasLabel = Boolean(props.title || props['aria-label'] || props['aria-labelledby']);
    const [icon, set] = useState('');
    const url = useMemo(() => {
        var _a, _b;
        // eslint-disable-next-line
        // @ts-ignore
        if ((_b = (_a = window === null || window === void 0 ? void 0 : window.env) === null || _a === void 0 ? void 0 : _a.ASSETS) === null || _b === void 0 ? void 0 : _b.includes('assets-t')) {
            return 'https://assets-t.storebrand.no/icons/';
        }
        return 'https://assets.storebrand.no/icons/';
    }, []);
    const combinedClassName = `icon icon-${name} ${className}`;
    useEffect(() => {
        const { href } = new URL(`${name}.svg`, url);
        const abortController = new AbortController();
        fetch(href, { signal: abortController.signal })
            .then((response) => {
            if (!response.ok) {
                throw new Error(`Can't find an icon with name ${name}!`);
            }
            return response.text();
        })
            .then((data) => set(data))
            .catch((error) => {
            if (error.name !== 'AbortError') {
                set(`Can't find an icon with name ${name}!`);
            }
        });
        return () => abortController.abort('Cancelling in cleanup');
    }, [name, url]);
    return (React.createElement(IconBase, Object.assign({ className: combinedClassName, dangerouslySetInnerHTML: { __html: icon } }, props, { 
        // Need to use role="img" for the screen reader to
        // interpret the component as an image and therefore
        // read the alternative label.
        role: hasLabel ? 'img' : undefined, "aria-hidden": !hasLabel })));
}
export const IconBase = styled.div `
  display: inline-flex;

  & > svg {
    width: 100%;
    height: 100%;
  }

  ${space};
  ${layout};
`;
export default Icon;
